<template>
  <resource-create-wrapper
    :title="$t('resources.alternative_contents.new_alternative_content')"
    :need-modal="showModal"
    @saveAction="$refs['alternativeContentForm'].submit()">
    <AlternativeContentForm
      :alternativeContent="item"
      @isDirtyForm="isDirtyForm"
      ref="alternativeContentForm"
      @finishedSaving="finishedSaving" />
    <template #actions>
      <v-btn @click="cancel" class="ml-auto cancel__btn" color="primary" outlined>
        {{ $t("generic.buttons.cancel") }}
      </v-btn>
      <v-btn @click="save" :loading="saveLoading" color="primary">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </template>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import AlternativeContentForm from "@/components/forms/AlternativeContentForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      AlternativeContentForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      /**
       * Item is provided here when duplicating
       */
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
      };
    },
    methods: {
      save() {
        this.saveLoading = true;
        this.showModal = false;
        this.$refs["alternativeContentForm"].submit();
      },
      cancel() {
        this.$router.push({ name: "alternative_contents_list" });
      },
      finishedSaving() {
        this.saveLoading = false;
      },
    },
  };
</script>
